import React from 'react';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';

import { taxesFormFields } from './taxesFormConfig';
import { Box } from '@mui/system';
import { TaxLiability } from './TaxLiability';
import { EqualizedMarketValue } from './EqualizedMarketValue';

const formConfig: FormOptions = {
  fields: taxesFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type TaxesProps = {
  form: Form;
};

const TaxesContainer = observer(({ form }: TaxesProps) => {
  return (
    <Grid container>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Paper key="taxes-panel" sx={{ p: 2, mb: 6 }}>
          <Typography variant="h6">Taxes</Typography>
          <Box sx={{ width: '100%', p: 2 }}>
            <TaxLiability form={form} />
          </Box>
          <Typography variant="h6">Projected Taxes</Typography>
          <Box sx={{ width: '100%', p: 1 }}>
            <EqualizedMarketValue form={form} />
          </Box>
        </Paper>
      </Stack>
    </Grid>
  );
});

export default wrapForm(formConfig)(TaxesContainer);
